module.exports = __webpack_public_path__ + "img/pic_document_add_bg_352@2x.4f1a8079.png";